import { Link } from 'react-router-dom';

interface Props {
  eyebrow?: string;
  title: string;
  sub?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({ eyebrow, title, sub, moreTo, moreLabel = '查看全部' }: Props) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        {eyebrow && (
          <p className="mb-1 text-xs font-medium uppercase tracking-widest text-primary-500">
            {eyebrow}
          </p>
        )}
        <h2 className="font-display text-2xl font-bold text-foreground-900 md:text-3xl">{title}</h2>
        {sub && <p className="mt-1.5 text-sm text-foreground-500">{sub}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      )}
    </div>
  );
}